export const SHORT_DATE_TIME = `MMMM D, YYYY h:mm A`;
export const LONG_DATE_TIME = `dddd, ${SHORT_DATE_TIME}`;